import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveIVA } from '../../shared/components';

export interface CreateIvaPageInterface {}

const CreateIvaPage: React.FC<CreateIvaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_iva);

  return <SaveIVA titlePage="Crear IVA" />;
};

export default CreateIvaPage;
